/**
 * RecommendationCard — 推荐卡片组件
 */

import { MapPin, Star, TrendingUp } from 'lucide-react';
import type { Destination, Poi } from '@/infrastructure/api/recommendations';

interface RecommendationCardProps {
  type: 'destination' | 'poi';
  data: Destination | Poi;
  onClick?: () => void;
}

export const RecommendationCard = ({ type, data, onClick }: RecommendationCardProps) => {
  const dest = data as Destination;
  const poi = data as Poi;

  return (
    <div
      onClick={onClick}
      className="group relative p-4 rounded-2xl bg-white/80 backdrop-blur-sm shadow-sm border border-white/50 hover:shadow-lg hover:scale-[1.02] transition-all cursor-pointer overflow-hidden"
    >
      {/* 背景装饰 */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

      <div className="relative">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">
            {type === 'destination' ? '热门目的地' : '推荐 POI'}
          </span>
          {(data as any).popularity && (
            <span className="flex items-center gap-0.5 text-xs text-gray-400">
              <TrendingUp className="w-3 h-3" />
              {(data as any).popularity}
            </span>
          )}
        </div>

        <h4 className="font-medium text-text-primary">
          {type === 'destination' ? dest.name : poi.name}
        </h4>

        <p className="text-xs text-gray-400 mt-1 line-clamp-2">
          {type === 'destination' ? dest.description : poi.description}
        </p>

        <div className="flex items-center gap-3 mt-3">
          {poi.rating && (
            <span className="flex items-center gap-0.5 text-xs text-amber-500">
              <Star className="w-3 h-3 fill-current" />
              {poi.rating}
            </span>
          )}
          {poi.city && (
            <span className="flex items-center gap-0.5 text-xs text-gray-400">
              <MapPin className="w-3 h-3" />
              {poi.city}
            </span>
          )}
          {poi.priceLevel && (
            <span className="text-xs text-gray-400">
              {'¥'.repeat(poi.priceLevel)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;
